import { InternalAxiosRequestConfig } from "axios";
import { CompaniesService } from "src/services/Companies/CompaniesService";

const QUESTIONNAIRE_POST_PATH =
    /^\/api\/(ssq-posts|diagnostic\/ssq-post_comment|diagnostic\/ssq-post_attachment|diagnostic\/questionnaire\/documents)(\/|\?|$)/;

const getPathname = (url: string | undefined): string | undefined => {
    if (url === undefined) {
        return undefined;
    }

    const withoutOrigin = url.replace(/^https?:\/\/[^/]+/, "");
    const pathStart = withoutOrigin.indexOf("/api/");

    return pathStart === -1 ? undefined : withoutOrigin.slice(pathStart);
};

export const isQuestionnairePostUrl = (url: string | undefined): boolean => {
    const path = getPathname(url);

    return path !== undefined && QUESTIONNAIRE_POST_PATH.test(path);
};

const hasOrganizationParam = (config: InternalAxiosRequestConfig): boolean => {
    const params = config.params as Record<string, unknown> | undefined;
    if (params?.organization_id !== undefined) {
        return true;
    }

    return /[?&]organization_id=/.test(config.url ?? "");
};

export const withQuestionnairePostOrganization = (
    config: InternalAxiosRequestConfig,
    selectedCompanyId: number | null = CompaniesService.getCurrentCompanyId(),
): InternalAxiosRequestConfig => {
    if (selectedCompanyId === null || Number.isNaN(selectedCompanyId)) {
        return config;
    }

    if (!isQuestionnairePostUrl(config.url) || hasOrganizationParam(config)) {
        return config;
    }

    config.params = { ...(config.params as Record<string, unknown> | undefined), organization_id: selectedCompanyId };

    return config;
};
